import React from 'react';
import RequiredInput from '../elements/required-input';
import { validators } from '../../../../utils/validators';

const CommunicationDetails = () => (
  <div>
    <RequiredInput
      controlId='email'
      label='Email address'
      model='.email'
      placeholder='Email'
      type='email'
      additionalValidators={{
        isEmail: validators.isEmail(this.updateErrors, 'email'),
      }}
    />
    <RequiredInput
      controlId='mobile'
      label='Mobile number'
      model='.mobile'
      placeholder='Mobile'
      type='tel'
    />
  </div>
);

export default CommunicationDetails;



// WEBPACK FOOTER //
// ./src/components/common/form/user/communication-details.jsx